import React, { useState } from 'react';
import '../../css/ProjectBlock.css';
import ResourcesBlock from "./ResourcesBlock";
import FilesBlock from "./FilesBlock";
import {getCurrentUser} from "../../services/authService";
import Translate from "../../components/Translate";

const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};


const ProjectBlock = ({ project }) => {
    const [selectedTab, setSelectedTab] = useState('Resources');
    const projectInitial = project?.name?.trim()?.charAt(0)?.toUpperCase() || '?';

    return (
        <div className="project-info">
            <div className="projects-info-choose ">
                <span className="project-title-with-logo">
                    <span className="project-letter-logo" aria-hidden="true">{projectInitial}</span>
                    <h2 className={'h2'}>{project.name}</h2>
                </span>
                <span
                    className={`projects-info-choose-item ${selectedTab === 'Resources' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('Resources')}
                >
                    <Translate language={currentUser.language} text={'resources'}/>
                </span>
                <span
                    className={`projects-info-choose-item ${selectedTab === 'Files' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('Files')}
                >
                    <Translate language={currentUser.language} text={'files'}/>
                </span>
            </div>

            {selectedTab === 'Resources' ? (
                <ResourcesBlock project={project} />
            ) : (
                <FilesBlock project={project} />
            )}
        </div>
    );
};

export default ProjectBlock;
